import type { Store } from '@/types/store';
import type { ProductItem, SectionItem, StoreItem } from '../types/myStore.types';
import { PAGE_TYPE_ICONS } from '../constants/myStore.constants';
import type { FC, SVGProps } from 'react';

export function getPageTypeIcon(pageType: string): FC<SVGProps<SVGSVGElement>> {
    return PAGE_TYPE_ICONS[pageType as keyof typeof PAGE_TYPE_ICONS] || PAGE_TYPE_ICONS.default;
}

export function transformStoreDataToItems(storeData: Store): StoreItem[] {
    const items: StoreItem[] = [];

    const allItems: Array<{ type: 'section' | 'page'; order: number; data: any }> = [];

    storeData.sections.forEach(section => {
        if (section.status === 1) {
            allItems.push({
                type: 'section',
                order: section.order,
                data: section,
            });
        }
    });

    storeData.pages.forEach(page => {
        if (page.status === 1 || page.status === 2) {
            allItems.push({
                type: 'page',
                order: page.order,
                data: page,
            });
        }
    });

    allItems.sort((a, b) => a.order - b.order);

    allItems.forEach(item => {
        if (item.type === 'section') {
            const section = item.data;
            const sectionItem: SectionItem = {
                id: `section-${section.section_id}`,
                type: 'section',
                title: section.data.title,
                section_id: section.section_id,
                order: section.order,
            };
            items.push(sectionItem);
        } else {
            const page = item.data;
            const productItem: ProductItem = {
                id: `page-${page.page_id}`,
                type: 'product',
                title: page.data.button.title || page.data.product.title,
                iconUrl: page.data.button.image,
                price: page.data.product.price.amount || undefined,
                page_id: page.page_id,
                page_type: page.type,
                status: page.status,
                location: page.data.location || 'store',
                slug: page.slug || undefined,
                order: page.order,
            };
            items.push(productItem);
        }
    });

    return items;
}
